{
  "timeOff.title": "الإجازات",
  "timeOff.hub.label": "أقسام الإجازات",
  "timeOff.hub.whosOut": "مين في إجازة",
  "timeOff.hub.requests": "الطلبات",
  "timeOff.hub.overtime": "الساعات الإضافية",
  "timeOff.hub.balances": "الأرصدة",
  "timeOff.hub.types": "أنواع الإجازات",
  "timeOff.hub.holidays": "العطلات الرسمية",
  "timeOff.days.count": "{count, plural, zero {لا أيام} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}",
  "timeOff.days.half": "نصف يوم",
  "timeOff.range.span": "{start} – {end}",
  "timeOff.range.half": "{date} · {label}",
  "timeOff.halfDay.none": "يوم كامل",
  "timeOff.halfDay.first_half": "النصف الأول",
  "timeOff.halfDay.second_half": "النصف الثاني",
  "timeOff.halfDay.choice.none": "يوم كامل",
  "timeOff.halfDay.choice.first_half": "النصف الأول من اليوم",
  "timeOff.halfDay.choice.second_half": "النصف الثاني من اليوم",
  "timeOff.status.pending": "في الانتظار",
  "timeOff.status.approved": "موافق عليها",
  "timeOff.status.rejected": "مرفوضة",
  "timeOff.status.cancelled": "سحبها الموظف",
  "timeOff.status.revoked": "أُلغيت بعد الموافقة",
  "timeOff.balance.grantedSplit": "{earned} مكتسبة في {year} حتى اليوم + {carried} مرحّلة أو مضافة",
  "timeOff.filters.status": "التصفية حسب الحالة",
  "timeOff.filters.statuses.all": "الكل",
  "timeOff.filters.statuses.pending": "في الانتظار",
  "timeOff.filters.statuses.approved": "موافق عليها",
  "timeOff.filters.statuses.rejected": "مرفوضة",
  "timeOff.filters.statuses.revoked": "أُلغيت بعد الموافقة",
  "timeOff.filters.statuses.cancelled": "سحبها الموظف",
  "timeOff.filters.month": "الشهر",
  "timeOff.filters.anyMonth": "كل الشهور",
  "timeOff.filters.type": "نوع الإجازة",
  "timeOff.filters.anyType": "كل أنواع الإجازات",
  "timeOff.filters.person": "الموظف",
  "timeOff.filters.anyone": "كل الموظفين",
  "timeOff.filters.searchPeople": "ابحث عن موظف",
  "timeOff.filters.noPeople": "لا يوجد موظف بهذا الاسم.",
  "timeOff.filters.clear": "مسح التصفية",
  "timeOff.calendar.out": "في إجازة",
  "timeOff.calendar.someone": "أحد الزملاء",
  "timeOff.calendar.separator": "، ",
  "timeOff.calendar.entrySeparator": "؛ ",
  "timeOff.calendar.today": "النهارده",
  "timeOff.calendar.holiday": "عطلة رسمية: {name}",
  "timeOff.calendar.nobodyOut": "مفيش حد في إجازة",
  "timeOff.calendar.outList": "{count, plural, one {شخص واحد في إجازة} two {شخصان في إجازة} few {# أشخاص في إجازة} many {# شخصًا في إجازة} other {# شخص في إجازة}}: {list}",
  "timeOff.calendar.outCount": "{count, plural, one {شخص واحد في إجازة} two {شخصان في إجازة} few {# أشخاص في إجازة} many {# شخصًا في إجازة} other {# شخص في إجازة}}",
  "timeOff.calendar.more": "+{count} آخرين",
  "timeOff.calendar.everyoneIn": "الفريق كله موجود.",
  "timeOff.calendar.weekend": "إجازة نهاية الأسبوع.",
  "timeOff.calendar.holidayEveryone": "عطلة رسمية للفريق كله.",
  "timeOff.calendar.previousMonth": "الشهر اللي فات",
  "timeOff.calendar.nextMonth": "الشهر الجاي",
  "timeOff.calendar.previousWeek": "الأسبوع اللي فات",
  "timeOff.calendar.nextWeek": "الأسبوع الجاي",
  "timeOff.calendar.weekLabel": "الأسبوع يومًا بيوم",
  "timeOff.calendar.legend": "معنى الألوان",
  "timeOff.calendar.legendPending": "في انتظار الموافقة",
  "timeOff.calendar.legendHalf": "نصف يوم",
  "timeOff.calendar.legendHoliday": "عطلة رسمية",
  "timeOff.calendar.loadError": "تعذّر تحميل الإجازات.",
  "timeOff.calendar.holidaysError": "تعذّر تحميل العطلات الرسمية، فلن تظهر على التقويم.",
  "timeOff.requests.caption": "طلبات الإجازة",
  "timeOff.requests.columns.person": "الموظف",
  "timeOff.requests.columns.kind": "نوع الإجازة",
  "timeOff.requests.columns.dates": "الأيام",
  "timeOff.requests.columns.status": "الحالة",
  "timeOff.requests.columns.requested": "تاريخ الطلب",
  "timeOff.requests.workingDays": "أيام العمل: {days}",
  "timeOff.requests.open": "فتح طلب {name}",
  "timeOff.requests.hasDocument": "مرفق به مستند",
  "timeOff.requests.sheetTitle": "طلب إجازة",
  "timeOff.requests.note": "ملاحظة",
  "timeOff.requests.document": "المستند",
  "timeOff.requests.documentMissing": "ناقص: مطلوب قبل الموافقة",
  "timeOff.requests.documentNone": "لا يوجد",
  "timeOff.requests.inboxHint": "عادةً يقرر المديرون والموارد البشرية من صندوق الطلبات.",
  "timeOff.requests.inboxLink": "فتح الطلبات",
  "timeOff.requests.loadError": "تعذّر تحميل طلبات الإجازة.",
  "timeOff.requests.empty.title": "لا توجد طلبات إجازة بعد",
  "timeOff.requests.empty.body": "تظهر الطلبات هنا أول ما حد يطلب إجازة.",
  "timeOff.requests.noMatch.title": "لا توجد نتائج بهذه التصفية",
  "timeOff.requests.noMatch.body": "جرّب شهرًا أو حالة أو موظفًا آخر، أو امسح التصفية.",
  "timeOff.decide.approve": "موافقة",
  "timeOff.decide.approving": "جارٍ الموافقة…",
  "timeOff.decide.approved": "تمت الموافقة على طلب {name}.",
  "timeOff.decide.reject": "رفض",
  "timeOff.decide.rejectTitle": "رفض طلب {name}؟",
  "timeOff.decide.rejectBody": "هيشوف سبب الرفض مع القرار.",
  "timeOff.decide.rejectReason": "سبب الرفض",
  "timeOff.decide.rejected": "تم رفض طلب {name}.",
  "timeOff.revoke.open": "إلغاء الإجازة",
  "timeOff.revoke.title": "إلغاء إجازة {name}؟",
  "timeOff.revoke.body": "تُلغى الإجازة ويرجع للرصيد {days}. ويُحفظ السبب في سجلّه.",
  "timeOff.revoke.confirm": "إلغاء الإجازة",
  "timeOff.revoke.done": "تم إلغاء إجازة {name}.",
  "timeOff.revoke.revokedTitle": "ألغتها الموارد البشرية",
  "timeOff.flow.title": "خطوات الموافقة",
  "timeOff.flow.label": "خطوات الموافقة",
  "timeOff.flow.requested": "تم الطلب",
  "timeOff.flow.requestedBy": "طلبها {name}",
  "timeOff.flow.approvedBy": "وافق {name}",
  "timeOff.flow.rejectedBy": "رفض {name}",
  "timeOff.flow.waitingFor": "في انتظار {name}",
  "timeOff.flow.then": "ثم {name}",
  "timeOff.flow.skipped": "{name}: تم التخطي",
  "timeOff.flow.hr": "الموارد البشرية",
  "timeOff.flow.manager": "المدير المباشر",
  "timeOff.flow.withdrawn": "تم سحب الطلب",
  "timeOff.flow.revoked": "ألغتها الموارد البشرية",
  "timeOff.overtime.caption": "سجل الساعات الإضافية",
  "timeOff.overtime.columns.when": "الموعد",
  "timeOff.overtime.columns.split": "نهاري وليلي",
  "timeOff.overtime.columns.kind": "نوع اليوم",
  "timeOff.overtime.columns.paidAs": "طريقة التعويض",
  "timeOff.overtime.columns.reason": "السبب",
  "timeOff.overtime.open": "فتح ساعات {name} الإضافية",
  "timeOff.overtime.sheetTitle": "ساعات إضافية",
  "timeOff.overtime.dayPart": "نهاري {duration}",
  "timeOff.overtime.nightPart": "ليلي {duration}",
  "timeOff.overtime.loadError": "تعذّر تحميل الساعات الإضافية.",
  "timeOff.overtime.empty.title": "لا توجد ساعات إضافية بعد",
  "timeOff.overtime.empty.body": "تظهر الساعات الإضافية هنا أول ما حد يسجّلها.",
  "timeOff.overtime.errors.day": "اختر اليوم.",
  "timeOff.overtime.errors.start": "اكتب وقت البداية.",
  "timeOff.overtime.errors.end": "اكتب وقت النهاية.",
  "timeOff.overtime.errors.span": "الساعات الإضافية من دقيقة لحد 16 ساعة.",
  "timeOff.overtime.errors.reason": "اكتب سببًا من 3 أحرف على الأقل.",
  "timeOff.dayKind.workday": "يوم عمل",
  "timeOff.dayKind.rest_day": "يوم راحة",
  "timeOff.dayKind.holiday": "عطلة رسمية",
  "timeOff.compensation.pay": "أجر",
  "timeOff.compensation.day_off": "بدل راحة",
  "timeOff.pay.title": "طريقة الحساب",
  "timeOff.pay.label": "طريقة حساب الساعات الإضافية",
  "timeOff.pay.rate": "×{rate}",
  "timeOff.pay.rateMinimum": "×{rate} على الأقل",
  "timeOff.pay.day": "الساعات النهارية ({duration}) بأجر الساعة الإضافية {rate}",
  "timeOff.pay.night": "الساعات الليلية ({duration})، من المغرب للشروق، بأجر الساعة الإضافية {rate}",
  "timeOff.pay.restDay": "{days, plural, one {أجر يوم} two {أجر يومين} few {أجر # أيام} many {أجر # يومًا} other {أجر # يوم}} عن العمل في يوم الراحة",
  "timeOff.pay.substituteDay": "ومعه يوم بدل راحة يُضاف إلى رصيد بدل الراحة",
  "timeOff.pay.holiday": "{days, plural, one {أجر يوم} two {أجر يومين} few {أجر # أيام} many {أجر # يومًا} other {أجر # يوم}} عن العمل في الإجازة الرسمية",
  "timeOff.pay.holidayDayOff": "يوم بدل راحة بدلًا من الأجر (بطلب كتابي)، يُضاف إلى رصيد بدل الراحة",
  "timeOff.balance.caption": "الأرصدة في {year}",
  "timeOff.balance.meter": "{used} مستخدمة و{pending} في الانتظار من أصل {total}",
  "timeOff.balance.granted": "الممنوح",
  "timeOff.balance.taken": "المستخدم",
  "timeOff.balance.removed": "ساقط أو مخصوم يدويًا",
  "timeOff.balance.pending": "في الانتظار",
  "timeOff.balance.available": "المتبقي",
  "timeOff.balances.title": "الأرصدة في {year}",
  "timeOff.balances.description": "المتبقي لكل موظف من كل نوع إجازة له رصيد خاص. الإجازة العارضة تُخصم من رصيد الاعتيادية.",
  "timeOff.balances.caption": "أرصدة إجازات الفريق في {year}",
  "timeOff.balances.of": "متبقي من {total}",
  "timeOff.balances.cellError": "تعذّر التحميل",
  "timeOff.balances.nothing": "لا رصيد",
  "timeOff.balances.loadError": "تعذّر تحميل الأرصدة.",
  "timeOff.balances.empty.title": "لا توجد ملفات وظيفية بعد",
  "timeOff.balances.empty.body": "تظهر الأرصدة بعد فتح ملفات الموظفين.",
  "timeOff.accrual.open": "منح أرصدة السنة",
  "timeOff.accrual.title": "منح أرصدة {year}؟",
  "timeOff.accrual.body": "كل موظف له ملف ياخد أيام {year} لكل نوع إجازة له رصيد خاص. والمتبقي من السنة اللي فاتت يُرحّل لحد الحد المسموح لكل نوع، والباقي يسقط.",
  "timeOff.accrual.safe": "تقدر تشغّله أكتر من مرة بأمان: اللي خد أيام {year} بالفعل يتم تخطيه، فمحدش ياخد رصيده مرتين.",
  "timeOff.accrual.confirm": "منح الأرصدة",
  "timeOff.accrual.running": "جارٍ المنح…",
  "timeOff.accrual.done": "{count, plural, one {تم منح رصيد واحد.} two {تم منح رصيدين.} few {تم منح # أرصدة.} many {تم منح # رصيدًا.} other {تم منح # رصيد.}}",
  "timeOff.accrual.nothing": "الكل خد أيام {year} بالفعل، ومفيش أي تغيير.",
  "timeOff.types.title": "أنواع الإجازات",
  "timeOff.types.description": "أنواع الإجازات المتاحة للطلب، وأجرها ورصيدها وقواعدها.",
  "timeOff.types.add": "إضافة نوع إجازة",
  "timeOff.types.caption": "أنواع الإجازات وقواعدها",
  "timeOff.types.columns.kind": "نوع الإجازة",
  "timeOff.types.columns.paid": "الأجر",
  "timeOff.types.columns.days": "الأيام في السنة",
  "timeOff.types.columns.rules": "القواعد",
  "timeOff.types.columns.status": "الحالة",
  "timeOff.types.columns.actions": "إجراءات",
  "timeOff.types.paidYes": "مدفوعة الأجر",
  "timeOff.types.paidNo": "بدون أجر",
  "timeOff.types.noBalance": "بدون رصيد",
  "timeOff.types.fromBalance": "من رصيد {name}",
  "timeOff.types.firstYear": "{days} في السنة الأولى",
  "timeOff.types.senior": "{days} بعد {years, plural, one {سنة} two {سنتين} few {# سنوات} many {# سنة} other {# سنة}}",
  "timeOff.types.cap": "بحد أقصى {days} في السنة",
  "timeOff.types.carries": "يُرحّل حتى {days}",
  "timeOff.types.halfDays": "نصف يوم",
  "timeOff.types.needsDocument": "تتطلب مستندًا",
  "timeOff.types.encashed": "تُصرف عند نهاية الخدمة",
  "timeOff.types.retired": "موقوفة",
  "timeOff.types.offered": "متاحة",
  "timeOff.types.edit": "تعديل {name}",
  "timeOff.types.editShort": "تعديل",
  "timeOff.types.newTitle": "نوع إجازة جديد",
  "timeOff.types.editTitle": "تعديل {name}",
  "timeOff.types.save": "حفظ نوع الإجازة",
  "timeOff.types.saving": "جارٍ الحفظ…",
  "timeOff.types.saved": "تم حفظ {name}.",
  "timeOff.types.created": "تمت إضافة {name}.",
  "timeOff.types.loadError": "تعذّر تحميل أنواع الإجازات.",
  "timeOff.types.empty.title": "لا توجد أنواع إجازات بعد",
  "timeOff.types.empty.body": "أضف أنواع الإجازات اللي يقدر الموظفين يطلبوها، زي الاعتيادية والمرضية.",
  "timeOff.types.sections.identity": "الاسم والشكل",
  "timeOff.types.sections.balance": "الأجر والرصيد",
  "timeOff.types.sections.rules": "القواعد",
  "timeOff.types.sections.law": "حسب قانون العمل",
  "timeOff.types.law.category": "النوع في القانون",
  "timeOff.types.law.categoryHint": "الاعتيادية بتتراكم شهر بشهر، والعارضة بتتخصم منها.",
  "timeOff.types.law.gender": "مين يقدر ياخدها",
  "timeOff.types.law.genderAny": "الكل",
  "timeOff.types.law.genderFemale": "السيدات",
  "timeOff.types.law.genderMale": "الرجال",
  "timeOff.types.law.payPercent": "نسبة الأجر (%)",
  "timeOff.types.law.payPercentHint": "100 يعني أجر كامل؛ المرضية حسب التأمينات (مثلًا 75).",
  "timeOff.types.law.perRequest": "أقصى أيام في الطلب الواحد",
  "timeOff.types.law.perRequestHint": "العارضة يومين بالكتير في المرة (م 128). سيبها فاضية لو مفيش حد.",
  "timeOff.types.law.timesInService": "عدد المرات طول مدة الخدمة",
  "timeOff.types.law.timesInServiceHint": "الوضع والأب: 3 مرات؛ الحج: مرة واحدة. فاضية يعني بدون حد.",
  "timeOff.types.law.minService": "أقل مدة خدمة (بالشهور)",
  "timeOff.types.law.minServiceHint": "الحج 60 شهر؛ رعاية الطفل 12.",
  "timeOff.types.law.minGap": "المدة بين مرتين (بالشهور)",
  "timeOff.types.law.minGapHint": "رعاية الطفل: 24 شهر بين الإجازتين (م 57).",
  "timeOff.types.law.minHeadcount": "أقل عدد عمال في الشركة",
  "timeOff.types.law.minHeadcountHint": "رعاية الطفل بتطبق لو الشركة 50 عامل أو أكتر (م 57).",
  "timeOff.types.law.calendarDays": "تتحسب بالأيام التقويمية",
  "timeOff.types.law.calendarDaysHint": "الوضع ورعاية الطفل بيتحسبوا كل الأيام، مش أيام الشغل بس.",
  "timeOff.types.category.annual": "اعتيادية",
  "timeOff.types.category.casual": "عارضة",
  "timeOff.types.category.sick": "مرضية",
  "timeOff.types.category.maternity": "وضع",
  "timeOff.types.category.paternity": "مولود (للأب)",
  "timeOff.types.category.childcare": "رعاية طفل",
  "timeOff.types.category.study": "دراسة وامتحانات",
  "timeOff.types.category.religious": "حج أو زيارة بيت المقدس",
  "timeOff.types.category.unpaid": "بدون أجر",
  "timeOff.types.category.compensatory": "بدل راحة",
  "timeOff.types.category.company": "سياسة الشركة",
  "timeOff.types.errors.percent": "اكتب نسبة من 0 لـ 100.",
  "timeOff.types.errors.whole": "اكتب رقم صحيح في الحدود، أو سيبها فاضية.",
  "timeOff.types.fields.nameAr": "الاسم بالعربية",
  "timeOff.types.fields.nameEn": "الاسم بالإنجليزية",
  "timeOff.types.fields.code": "الرمز",
  "timeOff.types.fields.codeHint": "حروف إنجليزية صغيرة وأرقام و_ (مثل annual)، وتستخدمه التقارير.",
  "timeOff.types.fields.position": "الترتيب",
  "timeOff.types.fields.positionHint": "الأرقام الأصغر تظهر أولًا في القوائم (من 0 إلى 100).",
  "timeOff.types.fields.color": "اللون على التقويم",
  "timeOff.types.fields.paid": "مدفوعة الأجر",
  "timeOff.types.fields.paidHint": "مدفوعة بالنسبة المحددة في «نسبة الأجر». الإجازة غير المدفوعة يُخصم عن كل يوم منها أجر يوم.",
  "timeOff.types.fields.deducts": "تُخصم من رصيد",
  "timeOff.types.fields.deductsHint": "كل يوم منها يُخصم من رصيد سنوي. والمرضية عادةً لا تُخصم.",
  "timeOff.types.fields.balance": "الرصيد",
  "timeOff.types.fields.balanceHint": "مثلًا الإجازة العارضة تُخصم من رصيد الاعتيادية.",
  "timeOff.types.fields.ownBalance": "رصيد خاص بها",
  "timeOff.types.fields.fromBalance": "رصيد {name}",
  "timeOff.types.fields.annualDays": "الأيام في السنة",
  "timeOff.types.fields.annualDaysHint": "تُمنح أول كل سنة مع الاستحقاق السنوي.",
  "timeOff.types.fields.firstYearDays": "في السنة الأولى",
  "timeOff.types.fields.firstYearDaysHint": "قبل إتمام سنة خدمة. اتركها فارغة لنفس الأيام المعتادة.",
  "timeOff.types.fields.seniorDays": "بعد مدة خدمة طويلة",
  "timeOff.types.fields.seniorDaysHint": "الأيام السنوية بعد ما الموظف يكمّل المدة المطلوبة.",
  "timeOff.types.fields.seniorAfterYears": "تبدأ المدة الطويلة بعد (سنوات)",
  "timeOff.types.fields.carryOver": "الترحيل بحد أقصى",
  "timeOff.types.fields.carryOverHint": "الأيام غير المستخدمة اللي تتنقل للسنة الجاية، والباقي يسقط. فارغة: لا ترحيل.",
  "timeOff.types.fields.yearlyCap": "أقصى أيام في السنة",
  "timeOff.types.fields.yearlyCapHint": "حد لأيام الإجازة في السنة حتى لو فيه رصيد. فارغة: بدون حد.",
  "timeOff.types.fields.halfDay": "يُسمح بنصف يوم",
  "timeOff.types.fields.halfDayHint": "يقدر الموظف يطلب النصف الأول أو الثاني من اليوم.",
  "timeOff.types.fields.attachment": "تتطلب مستندًا",
  "timeOff.types.fields.attachmentHint": "مثل الشهادة الطبية، ولا تتم الموافقة بدونها.",
  "timeOff.types.fields.encash": "تُصرف عند نهاية الخدمة",
  "timeOff.types.fields.encashHint": "لما الموظف يسيب الشغل، تُصرف له أيامه المتبقية من النوع ده بقيمة أجر اليوم في المخالصة النهائية.",
  "timeOff.types.fields.active": "متاحة للطلب",
  "timeOff.types.fields.activeHint": "ألغِ التحديد لإيقافها: تفضل الإجازات السابقة في السجل، لكن محدش يقدر يطلبها.",
  "timeOff.types.errors.code": "استخدم من 2 إلى 30 حرفًا إنجليزيًا صغيرًا أو رقمًا أو _، يبدأ بحرف.",
  "timeOff.types.errors.required": "هذا الحقل مطلوب.",
  "timeOff.types.errors.days": "اكتب عدد أيام من 0 إلى 365، بحد أقصى رقمين عشريين.",
  "timeOff.types.errors.positive": "اكتب رقمًا أكبر من 0، أو اتركه فارغًا.",
  "timeOff.types.errors.years": "اكتب عدد سنوات صحيحًا من 1 إلى 50.",
  "timeOff.types.errors.seniority": "اكتب أيام المدة الطويلة وعدد سنواتها معًا، أو اتركهما فارغين.",
  "timeOff.types.errors.position": "اكتب رقمًا صحيحًا من 0 إلى 100.",
  "timeOff.colors.sage": "زيتي",
  "timeOff.colors.sky": "سماوي",
  "timeOff.colors.sand": "رملي",
  "timeOff.colors.rose": "وردي",
  "timeOff.colors.lilac": "بنفسجي",
  "timeOff.colors.teal": "فيروزي",
  "timeOff.colors.slate": "رمادي",
  "timeOff.holidays.title": "العطلات الرسمية في {year}",
  "timeOff.holidays.description": "أيام لا يُنتظر فيها حضور أحد، ولا تُحسب من الإجازات.",
  "timeOff.holidays.add": "إضافة عطلة رسمية",
  "timeOff.holidays.addTitle": "إضافة عطلة رسمية",
  "timeOff.holidays.editTitle": "تعديل الإجازة الرسمية",
  "timeOff.holidays.dialogBody": "اليوم واسم الإجازة باللغتين.",
  "timeOff.holidays.save": "حفظ الإجازة",
  "timeOff.holidays.added": "تمت إضافة الإجازة الرسمية.",
  "timeOff.holidays.saved": "تم حفظ الإجازة الرسمية.",
  "timeOff.holidays.fields.day": "اليوم",
  "timeOff.holidays.fields.nameAr": "الاسم بالعربية",
  "timeOff.holidays.fields.nameEn": "الاسم بالإنجليزية",
  "timeOff.holidays.errors.day": "اختر اليوم.",
  "timeOff.holidays.errors.name": "اكتب اسم الإجازة.",
  "timeOff.holidays.next": "القادمة",
  "timeOff.holidays.edit": "تعديل {name}",
  "timeOff.holidays.remove": "حذف {name}",
  "timeOff.holidays.removeTitle": "حذف {name}؟",
  "timeOff.holidays.removeBody": "هيرجع اليوم يوم عمل عادي في الحضور والإجازات.",
  "timeOff.holidays.removeConfirm": "حذف الإجازة",
  "timeOff.holidays.removed": "تم حذف {name}.",
  "timeOff.holidays.loadError": "تعذّر تحميل العطلات الرسمية.",
  "timeOff.holidays.empty.title": "لا توجد إجازات رسمية في {year} بعد",
  "timeOff.holidays.empty.body": "أضف العطلات الرسمية للسنة علشان الحضور والإجازات يتخطّوها.",
  "timeOff.holidays.empty.bodyReadOnly": "تضيف الموارد البشرية العطلات الرسمية للسنة هنا.",
  "timeOff.year.label": "السنة",
  "timeOff.year.previous": "السنة اللي فاتت",
  "timeOff.year.next": "السنة الجاية",
  "timeOff.year.value": "{year}",
  "timeOff.ledger.caption": "سجل الرصيد في {year}",
  "timeOff.ledger.columns.when": "التاريخ",
  "timeOff.ledger.columns.what": "الحركة",
  "timeOff.ledger.columns.change": "الأيام",
  "timeOff.ledger.columns.by": "بواسطة",
  "timeOff.ledger.automatic": "تلقائي",
  "timeOff.ledger.kind.grant": "الرصيد السنوي",
  "timeOff.ledger.auto.grant": "مُنح مع الاستحقاق السنوي.",
  "timeOff.ledger.kind.request": "إجازة مستخدمة",
  "timeOff.ledger.auto.request": "إجازة تمت الموافقة عليها.",
  "timeOff.ledger.kind.reversal": "إجازة مُستردّة",
  "timeOff.ledger.auto.reversal": "إجازة اتلغت ورجعت أيامها.",
  "timeOff.ledger.kind.adjustment": "تعديل يدوي",
  "timeOff.ledger.auto.adjustment": "تعديل يدوي.",
  "timeOff.ledger.kind.carry_over": "رصيد مرحّل",
  "timeOff.ledger.auto.carry_over": "أيام متبقية مرحّلة من السنة اللي فاتت.",
  "timeOff.ledger.kind.expiry": "رصيد ساقط",
  "timeOff.ledger.auto.expiry": "أيام متبقية سقطت بنهاية السنة.",
  "timeOff.ledger.kind.compensatory": "بدل راحة",
  "timeOff.ledger.auto.compensatory": "مستحق عن العمل في يوم راحة أو عطلة رسمية.",
  "timeOff.ledger.kind.advance": "رصيد مقدَّم",
  "timeOff.ledger.auto.advance": "إجازة سمحت بها الموارد البشرية قبل استحقاقها.",
  "timeOff.ledger.kind.settlement": "تسوية رصيد",
  "timeOff.ledger.auto.settlement": "أيام اتصرف مقابلها أو اتفق على تسويتها، بسبب من الموارد البشرية.",
  "timeOff.profile.title": "الإجازات",
  "timeOff.profile.description": "أرصدة {name} وكل حركة عليها، ومين عملها وليه.",
  "timeOff.profile.balances": "الأرصدة في {year}",
  "timeOff.profile.history": "السجل في {year}",
  "timeOff.profile.requestsLink": "طلبات إجازته",
  "timeOff.profile.loadError": "تعذّر تحميل بيانات الإجازات.",
  "timeOff.profile.noBalances.title": "لا توجد أرصدة في {year}",
  "timeOff.profile.noBalances.body": "شغّل الاستحقاق السنوي من الإجازات › الأرصدة، أو عدّل الرصيد يدويًا.",
  "timeOff.profile.noBalances.bodyReadOnly": "تمنح الموارد البشرية أيام السنة مع الاستحقاق السنوي.",
  "timeOff.profile.noHistory.title": "لا توجد حركات بعد",
  "timeOff.profile.noHistory.body": "تظهر هنا الأرصدة الممنوحة والإجازات والتعديلات في {year}.",
  "timeOff.adjust.open": "تعديل الرصيد",
  "timeOff.adjust.compensatoryOpen": "إضافة بدل راحة",
  "timeOff.adjust.title": "تعديل رصيد {name}",
  "timeOff.adjust.body": "أضف أو اخصم أيامًا من رصيد {year}. ويُحفظ التعديل والسبب في السجل.",
  "timeOff.adjust.compensatoryTitle": "إضافة بدل راحة لـ{name}",
  "timeOff.adjust.compensatoryBody": "يوم راحة مستحق عن العمل في يوم راحة أو عطلة رسمية، يُضاف إلى رصيد بدل الراحة في {year}.",
  "timeOff.adjust.kind": "الرصيد",
  "timeOff.adjust.direction": "نوع التعديل",
  "timeOff.adjust.add": "إضافة أيام",
  "timeOff.adjust.remove": "خصم أيام",
  "timeOff.adjust.amount": "عدد الأيام",
  "timeOff.adjust.amountHint": "نصف اليوم يُكتب 0.5.",
  "timeOff.adjust.preview": "المتبقي من {name}:",
  "timeOff.adjust.reason": "السبب",
  "timeOff.adjust.reasonHint": "يُحفظ في السجل، مثل \"اشتغل الجمعة 10 أكتوبر في الإطلاق\".",
  "timeOff.adjust.save": "حفظ التعديل",
  "timeOff.adjust.credit": "إضافة اليوم",
  "timeOff.adjust.saved": "تم تعديل رصيد {name}.",
  "timeOff.adjust.credited": "تمت إضافة بدل راحة لـ{name}.",
  "timeOff.adjust.errors.type": "اختر الرصيد.",
  "timeOff.adjust.errors.amount": "اكتب عدد أيام من 0.5 إلى 365، بحد أقصى رقمين عشريين.",
  "timeOff.adjust.errors.reason": "اكتب سببًا من 3 أحرف على الأقل.",
  "timeOff.mine.title": "إجازاتي",
  "timeOff.mine.description": "أرصدتك وطلبات إجازتك وساعاتك الإضافية.",
  "timeOff.mine.balances": "أرصدتي في {year}",
  "timeOff.mine.balancesError": "تعذّر تحميل أرصدتك.",
  "timeOff.mine.daysLeft": "{count, plural, one {يوم متبقٍ} two {يومان متبقيان} few {أيام متبقية} many {يومًا متبقيًا} other {يوم متبقٍ}}",
  "timeOff.mine.figures": "{used} مستخدمة · {pending} في الانتظار · من {total}",
  "timeOff.mine.accrued": "{days} مستحقة لحد دلوقتي السنة دي، شهر بشهر",
  "timeOff.mine.usableFrom": "الأيام المستحقة تقدر تستخدمها من {date}، بعد ستة شهور خدمة",
  "timeOff.mine.shared": "{list} تُخصم أيضًا من الرصيد ده.",
  "timeOff.mine.noBalances.title": "لا توجد أرصدة في {year} بعد",
  "timeOff.mine.noBalances.body": "تمنح الموارد البشرية أيام كل سنة في أولها.",
  "timeOff.mine.viewLabel": "عرض",
  "timeOff.mine.leaveTab": "طلبات الإجازة",
  "timeOff.mine.overtimeTab": "الساعات الإضافية",
  "timeOff.mine.requestsError": "تعذّر تحميل طلباتك.",
  "timeOff.mine.overtimeError": "تعذّر تحميل ساعاتك الإضافية.",
  "timeOff.mine.noRequests.title": "لا توجد طلبات إجازة بعد",
  "timeOff.mine.noRequests.body": "اطلب إجازتك وتابعها هنا لحد ما مديرك والموارد البشرية يقرروا.",
  "timeOff.mine.noOvertime.title": "لا توجد ساعات إضافية بعد",
  "timeOff.mine.noOvertime.body": "سجّل الساعات الإضافية بعد ما تشتغلها: مديرك والموارد البشرية يوافقوا عليها، والرواتب تصرفها.",
  "timeOff.mine.requestFacts": "{days} · طُلبت في {date}",
  "timeOff.mine.revokedBecause": "ألغت الموارد البشرية الإجازة:",
  "timeOff.mine.documentNeeded": "الإجازة دي محتاجة مستند قبل الموافقة.",
  "timeOff.mine.progress": "خطوات الموافقة",
  "timeOff.mine.openDocument": "فتح المستند",
  "timeOff.mine.withdraw": "سحب الطلب",
  "timeOff.mine.keep": "إبقاء الطلب",
  "timeOff.mine.withdrawTitle": "سحب الطلب؟",
  "timeOff.mine.withdrawBody": "هيتلغي طلبك عن {date}، ومحدش هيحتاج يقرر فيه.",
  "timeOff.mine.withdrawn": "تم سحب الطلب.",
  "timeOff.mine.withdrawOvertimeTitle": "سحب الساعات الإضافية؟",
  "timeOff.mine.withdrawOvertimeBody": "هتتلغي ساعاتك الإضافية يوم {date} قبل ما حد يقرر فيها.",
  "timeOff.mine.overtimeWithdrawn": "تم سحب الساعات الإضافية.",
  "timeOff.mine.noRecord.title": "إجازاتك هتظهر بعد ما الموارد البشرية تفتح ملفك",
  "timeOff.mine.noRecord.body": "الموارد البشرية بتفتح ملفًا لكل عضو في الفريق. أول ما ملفك يجهز هتظهر هنا أرصدتك وطلباتك.",
  "timeOff.request.open": "طلب إجازة",
  "timeOff.request.title": "طلب إجازة",
  "timeOff.request.description": "الطلب بيروح لمديرك المباشر الأول، وبعدين للموارد البشرية.",
  "timeOff.request.kind": "نوع الإجازة",
  "timeOff.request.kindLeft": "المتبقي {left}",
  "timeOff.request.kindShared": "من رصيد {name}",
  "timeOff.request.kindFree": "لا تُخصم من رصيد",
  "timeOff.request.kindUnpaid": "يُخصم أجر يوم عن كل يوم",
  "timeOff.request.kindDocument": "تتطلب مستندًا",
  "timeOff.request.from": "أول يوم",
  "timeOff.request.to": "آخر يوم",
  "timeOff.request.length": "المدة",
  "timeOff.request.document": "المستند",
  "timeOff.request.documentHint": "مثل الشهادة الطبية، ولا تتم الموافقة بدونها.",
  "timeOff.request.note": "ملاحظة",
  "timeOff.request.noteHint": "اختياري. أي حاجة مديرك محتاج يعرفها.",
  "timeOff.request.send": "إرسال الطلب",
  "timeOff.request.sending": "جارٍ الإرسال…",
  "timeOff.request.sent": "تم إرسال طلب الإجازة، ومديرك هيشوفه الأول.",
  "timeOff.request.sentWithoutDocument": "اتبعت طلبك لكن المستند ما اترفعش. أرفقه من طلباتك.",
  "timeOff.request.noKinds": "لا توجد أنواع إجازات متاحة بعد، والموارد البشرية هي اللي بتضيفها.",
  "timeOff.request.errors.type": "اختر نوع الإجازة.",
  "timeOff.request.errors.start": "اختر أول يوم.",
  "timeOff.request.errors.end": "اختر آخر يوم.",
  "timeOff.request.errors.order": "آخر يوم لازم يكون بعد أول يوم.",
  "timeOff.request.errors.oneYear": "اطلب كل سنة ميلادية في طلب منفصل.",
  "timeOff.request.errors.halfNotAllowed": "النوع ده بيتاخد أيام كاملة بس.",
  "timeOff.request.errors.halfSingleDay": "نصف اليوم ليوم واحد بس.",
  "timeOff.request.errors.attachment": "أرفق المستند المطلوب للإجازة دي.",
  "timeOff.estimate.days": "حوالي {days}",
  "timeOff.estimate.leaves": "هيتبقى {left} من رصيد {name}.",
  "timeOff.estimate.short": "أكتر من المتبقي في رصيد {name} ({left}).",
  "timeOff.estimate.note": "تقدير مبدئي: أيام الراحة والعطلات الرسمية لا تُحسب، وبنعيد العدّ عند الإرسال.",
  "timeOff.estimate.noteAgencyWeek": "تقدير مبدئي يعتبر الأحد للخميس أيام عمل لأن جدولك الأسبوعي ما اتقراش، وبنعيد العدّ عند الإرسال.",
  "timeOff.estimate.problem.order": "آخر يوم قبل أول يوم.",
  "timeOff.estimate.problem.years": "الإجازة لازم تكون في سنة ميلادية واحدة؛ اطلب كل سنة لوحدها.",
  "timeOff.estimate.problem.halfRange": "نصف اليوم ليوم واحد بس.",
  "timeOff.estimate.problem.halfOff": "اليوم ده راحة أو عطلة رسمية، فمش هيتخصم منك.",
  "timeOff.estimate.problem.noWorkingDays": "كل الأيام دي راحة أو إجازات رسمية، فمفيش حاجة تطلبها.",
  "timeOff.record.open": "تسجيل ساعات إضافية",
  "timeOff.record.title": "تسجيل ساعات إضافية",
  "timeOff.record.description": "مديرك والموارد البشرية بيوافقوا عليها، والرواتب بتصرفها.",
  "timeOff.record.day": "اليوم",
  "timeOff.record.start": "من",
  "timeOff.record.end": "إلى",
  "timeOff.record.total": "إجمالي الساعات الإضافية: {duration}",
  "timeOff.record.nextDay": "(بتخلص اليوم اللي بعده)",
  "timeOff.record.kindUnknown": "هنعرف نوع اليوم بعد الإرسال.",
  "timeOff.record.ruleDay": "الساعات النهارية بأجر الساعة الإضافية {rate}",
  "timeOff.record.ruleNight": "الساعات الليلية (من المغرب للشروق) بأجر الساعة الإضافية {rate}",
  "timeOff.record.compensation": "عايز التعويض إزاي؟",
  "timeOff.record.pay": "أجر",
  "timeOff.record.payHint": "أجر الإجازة الرسمية: ضعف أجر اليوم حسب القانون.",
  "timeOff.record.dayOff": "بدل راحة",
  "timeOff.record.dayOffHint": "اختيارك ده بيُعتبر طلبك الكتابي ليوم بدل راحة.",
  "timeOff.record.reason": "السبب",
  "timeOff.record.reasonHint": "اشتغلت على إيه، علشان مديرك يعرف.",
  "timeOff.record.send": "إرسال للموافقة",
  "timeOff.record.sending": "جارٍ الإرسال…",
  "timeOff.record.sent": "تم إرسال الساعات الإضافية للموافقة.",
  "timeOff.attach.open": "إرفاق مستند",
  "timeOff.attach.title": "إرفاق مستند",
  "timeOff.attach.body": "ملف PDF أو صورة لحد 10 ميجابايت، والموارد البشرية هتشوفه مع طلبك.",
  "timeOff.attach.send": "إرفاق",
  "timeOff.attach.sending": "جارٍ الرفع…",
  "timeOff.attach.done": "تم إرفاق المستند.",
  "timeOff.errors.typeNotFound": "نوع الإجازة ده لم يعد موجودًا.",
  "timeOff.errors.codeTaken": "فيه نوع إجازة تاني بيستخدم الرمز ده.",
  "timeOff.errors.requestNotFound": "تعذّر العثور على الطلب.",
  "timeOff.errors.overlap": "إنت طالب إجازة بالفعل في بعض الأيام دي.",
  "timeOff.errors.invalid": "اختر أيام عمل في سنة واحدة؛ ونصف اليوم ليوم واحد بس.",
  "timeOff.errors.balance": "رصيدك مش كفاية للإجازة دي.",
  "timeOff.errors.attachmentRequired": "الإجازة دي محتاجة مستندها قبل الموافقة.",
  "timeOff.errors.notEligible": "النوع ده من الإجازات مش متاح ليك لسه.",
  "timeOff.errors.tooLongForKind": "عدد الأيام أكتر من المسموح بيه للنوع ده في المرة الواحدة.",
  "timeOff.errors.timesUsed": "النوع ده من الإجازات اتاخد أقصى عدد مرات يسمح بيه القانون.",
  "timeOff.errors.belowLaw": "القانون بيدّي أكتر من كده. السياسة ممكن تكون أسخى بس.",
  "timeOff.errors.attachmentType": "أرفق ملف PDF أو PNG أو JPEG أو WebP لحد 10 ميجابايت.",
  "timeOff.errors.overtimeNotFound": "تعذّر العثور على الساعات الإضافية.",
  "timeOff.errors.overtimeInvalid": "الساعات الإضافية لحد 16 ساعة، وفي حدود 60 يوم من النهارده.",
  "timeOff.errors.holidayExists": "اليوم ده عطلة رسمية بالفعل.",
  "timeOff.errors.holidayNotFound": "تعذّر العثور على الإجازة الرسمية.",
  "timeOff.errors.periodLocked": "الشهر ده مقفول للرواتب.",
  "timeOff.errors.periodFinal": "حضور الشهر ده نهائي، ولازم الموارد البشرية تعيد فتحه الأول.",
  "timeOff.errors.noRecord": "لا يوجد ملف وظيفي للشخص ده بعد.",
  "timeOff.errors.requestClosed": "الطلب ده اتقرر فيه أو اتسحب بالفعل.",
  "timeOff.errors.notYourDecision": "الخطوة دي مش من صلاحيتك.",
  "timeOff.errors.tooLong": "النص أطول من المسموح."
}
